import React, { ReactNode } from 'react';
import { JobApplicantsStore } from './job-applicatns-store';

const JobApplicantsContext = React.createContext<JobApplicantsStore  | null>(null);

export const JobApplicantsProvider = ({ children }: { children: ReactNode }) => {
   const [store] = React.useState< JobApplicantsStore >(() => new  JobApplicantsStore());

   return <JobApplicantsContext.Provider value={store}>{children}</JobApplicantsContext.Provider>;
};

export const useJobApplicants = () => {
   const ctx = React.useContext(JobApplicantsContext);
   if (!ctx) {
      throw new Error('useJobApplicants must be used inside JobApplicantsProvider');
   }
   return ctx;
};
